import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  textPublication: {
    fontSize: 24,
  },
  bodyBox: {
    backgroundColor: Colors.Grey1,
    width: '100%',
    padding: 24,
    border: `1px solid ${Colors.Grey3}`,
    marginTop: 16,
  },
  wrapIosSwitch: {
    display: 'flex',
    alignItems: 'center',
  },
  textPublicProfile: {
    fontSize: 14,
  },
  wrapButtonAdd: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 16,
  },
  buttonAdd: {
    '&.MuiButton-root': {
      padding: '8px 16px',
      width: 90,
      height: 44,
    },
  },
  textFieldError: {
    '& .MuiInputBase-input': {
      padding: '12px 8px',
      border: `1px solid red`,
    },
  },
  textFieldStyle: {
    '& .MuiInputBase-input': {
      padding: '12px 8px',
      backgroundColor: Colors.White,
    },
  },
  textAddEventAutomatic: {
    marginTop: 8,
    fontSize: 12,
    color: Colors.Grey8,
  },
}));

export default useStyles;
